import styled, { css } from "styled-components";

export const ProgressContainer = styled.div`
  ${({ color }) => css`
    width: 100%;
    background: ${color};
  `}
`;
